mutation UpdateWidget($id: ID!, $input: UpdateWidgetInput!) {
  updateWidget(id: $id, input: $input) {
    id
    title
    buttonUrl
    buttonText
    buttonColor
    buttonTextColor
    hits
    clicks
    ctr
    createdAt
  }
}
